import type { Edl } from './edl.js';

export function sourceUsage(edl: Edl, assetId: string): { status: 'used' | 'partial' | 'omitted'; usedS: number; reason: string } {
  const source = edl.sources?.find(s => s.asset_id === assetId);
  const usedS = edl.timeline.filter(s => s.asset_id === assetId).reduce((n, s) => n + s.src_out - s.src_in, 0);
  const reasons = [...new Set(edl.omissions?.filter(s => s.asset_id === assetId).map(s => s.reason) ?? [])];
  return { status: usedS < 0.001 ? 'omitted' : source && usedS < source.duration_s - 0.1 ? 'partial' : 'used', usedS, reason: reasons.join('; ') };
}
